import { z } from 'zod';

export const imageAssetSchema = z.object({
  width: z.number(),
  height: z.number(),
  files: z.array(
    z.object({
      size: z.number(),
      url: z.string(),
    }),
  ),
});
export type Asset = z.infer<typeof imageAssetSchema>;

export const imageAssetSchemaWithId = imageAssetSchema.and(
  z.object({
    id: z.number(),
  }),
);
export type AssetWithId = z.infer<typeof imageAssetSchemaWithId>;
